import React, { useEffect, useState } from "react";
import axiosClient from "../../../../config/axios.js";
import Swal from "sweetalert2";
import { Row, Col, Form, Badge } from "react-bootstrap";
import Loader from "../../../../components/loader/index.js";

const ModalUpdateOrderStatus = ({
  idOrder,
  modalUpdateOrderStatus,
  onStatusUpdated,
  modalInstance,
}) => {
  const [statuses, setStatuses] = useState([]);
  const [currentStatusId, setCurrentStatusId] = useState(null);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [orderFolio, setOrderFolio] = useState(null);
  const [loading, setLoading] = useState(true);

  const statusFlows = {
    CONTADO: [
      { step: 1, status: "SIN_ASIGNAR" },
      { step: 2, status: "ASIGNADA_SIN_ENVIAR" },
      { step: 3, status: "ENVIADA" },
      { step: 4, status: "CONTACTO" },
      { step: 5, status: "LLEGADA" },
      { step: 6, status: "PAGADO_CONTADO" },
      { step: 7, status: "ENTREGA" },
      { step: 8, status: "EVALUADO" },
      { step: 9, status: "CIERRE" },
      { step: 10, status: "CANCELADO_PAGO_PENDIENTE" },
      { step: 11, status: "CANCELADO" },
    ],
    CREDITO: [
      { step: 1, status: "SIN_ASIGNAR" },
      { step: 2, status: "ASIGNADA_SIN_ENVIAR" },
      { step: 3, status: "ENVIADA" },
      { step: 4, status: "CONTACTO" },
      { step: 5, status: "LLEGADA" },
      { step: 6, status: "ENTREGA" },
      { step: 7, status: "EVALUADO" },
      { step: 8, status: "PAGADO_CREDITO" },
      { step: 9, status: "CIERRE" },
      { step: 10, status: "CANCELADO_PAGO_PENDIENTE" },
      { step: 11, status: "CANCELADO" },
    ],
    "CONTADO/CREDITO": [
      { step: 1, status: "SIN_ASIGNAR" },
      { step: 2, status: "ASIGNADA_SIN_ENVIAR" },
      { step: 3, status: "ENVIADA" },
      { step: 4, status: "CONTACTO" },
      { step: 5, status: "LLEGADA" },
      { step: 6, status: "PAGADO_CONTADO" },
      { step: 7, status: "ENTREGA" },
      { step: 8, status: "EVALUADO" },
      { step: 9, status: "PAGADO_CREDITO" },
      { step: 10, status: "CIERRE" },
      { step: 11, status: "CANCELADO_PAGO_PENDIENTE" },
      { step: 12, status: "CANCELADO" },
    ],
  };

  // cargar datos de la orden
  const loadOrderData = async (orderId) => {
    try {
      setLoading(true);

      const res = await axiosClient.get(`/orders/${orderId}`);
      const { current_order_status_id, folio, PaymentType } = res.data;
      setCurrentStatusId(current_order_status_id);
      setOrderFolio(folio);

      const paymentTypeCode = PaymentType?.payment_type_code || "CONTADO"; // fallback si no existe
      const flow = statusFlows[paymentTypeCode] || statusFlows["CONTADO"];

      const res2 = await axiosClient.get("/orderStatuses/allWithOrderCount");
      const allStatuses = res2.data.data || [];

      // status actual
      const statusActual = allStatuses.find(
        (st) => st.id === current_order_status_id
      );
      setCurrentStatus(statusActual);

      if (!statusActual) {
        setStatuses([]);
        return;
      }

      // buscar en el flujo cuál es el actual
      const flowIndex = flow.findIndex(
        (f) => f.status === statusActual.order_status_code
      );

      // tomar solo los anteriores en el flujo
      const anteriores = flow.slice(0, flowIndex).map((f) => f.status);

      // mapear contra la lista completa (manteniendo id del backend)
      const filteredStatuses = allStatuses.filter((st) =>
        anteriores.includes(st.order_status_code)
      );

      setStatuses(filteredStatuses);
      setSelectedStatus("");
    } catch (err) {
      console.error("Error cargando datos:", err);
    } finally {
      setLoading(false);
    }
  };

  // cargar datos al abrir modal
  useEffect(() => {
    const modalEl = modalUpdateOrderStatus.current;
    if (!modalEl) return;

    const handleShown = () => {
      if (idOrder) loadOrderData(idOrder);
    };

    modalEl.addEventListener("shown.bs.modal", handleShown);
    return () => {
      modalEl.removeEventListener("shown.bs.modal", handleShown);
    };
  }, [idOrder]);

  const handleUpdateStatus = () => {
    if (!selectedStatus) return;

    Swal.fire({
      title: "¿Actualizar estatus?",
      text: "Se actualizará el estatus de la orden.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, actualizar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axiosClient
          .put(`/orders/${idOrder}/currentOrderStatus`, {
            current_order_status_id: selectedStatus,
          })
          .then(() => {
            Swal.fire(
              "¡Actualizado!",
              "El estatus de la orden se actualizó correctamente.",
              "success"
            ).then(() => {
              if (modalInstance) {
                modalInstance.hide();
              }
              if (onStatusUpdated) onStatusUpdated();
            });
          })
          .catch((err) => {
            console.error("Error actualizando estatus:", err);
            Swal.fire("Error", "No se pudo actualizar el estatus.", "error");
          });
      }
    });
  };

  return (
    <div className="modal fade" ref={modalUpdateOrderStatus}>
      <div className="modal-dialog modal-print">
        <div className="modal-content">
          {loading ? (
            <Loader isLoading={true} />
          ) : (
            <>
              <div className="p-3 border-bottom">
                <h5 className="mb-1">
                  Folio de la orden #
                  {orderFolio ? orderFolio.toString().padStart(5, "0") : ""}
                </h5>
                <h5 className="mb-1">Id de la orden {idOrder}</h5>
                <br></br>
                {currentStatus && (
                  <Badge bg={currentStatus.color} className="mt-1">
                    Estatus actual: {currentStatus.order_status}
                  </Badge>
                )}
              </div>

              <div className="p-3">
                <Row>
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="fw-bold">
                        Selecciona un nuevo estatus
                      </Form.Label>
                      <Form.Select
                        value={selectedStatus}
                        onChange={(e) => setSelectedStatus(e.target.value)}
                      >
                        <option value="">-- Selecciona --</option>
                        {statuses.map((st) => (
                          <option key={st.id} value={st.id}>
                            {st.order_status}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <div className="mt-4 text-end">
                  <button
                    className="btn btn-primary btn-lg"
                    disabled={!selectedStatus}
                    onClick={handleUpdateStatus}
                  >
                    Actualizar estatus
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalUpdateOrderStatus;
